import { AxiosError } from 'axios';
import { t } from 'i18next';
import { backendErrorNotification, frontendNotification } from '../../../components/Notification';
import HttpStatus from '../../../enums/httpStatus';
import { SellerParameterNamesEnum } from '../../../enums/sellerParameterNames';
import { sellersParametersApi } from '../../requests';
import { processReportReq } from '../reports';

const getReportIdToPdfOrder = async () => {
  try {
    sellersParametersApi.query = '';
    const response = await sellersParametersApi.show(
      SellerParameterNamesEnum.REPORT_ID_TO_DOWNLOAD_PDF_ORDER,
    );

    if (response.status === HttpStatus.OK && response.data.data) {
      return response.data.data.valor;
    } else {
      throw response;
    }
  } catch (err) {
    if (!sellersParametersApi.axios.isCancel(err)) {
      backendErrorNotification(err as AxiosError<any, any>);
    }
  }
};

export const downlaodOrderApi = async (orderNumber: string) => {
  try {
    const reportId = await getReportIdToPdfOrder();

    const res = await processReportReq(reportId, 'pdf', [
      {
        label: 'NumeroPedido',
        value: orderNumber,
      },
    ]);

    if (res.status === HttpStatus.OK) {
      const fileType = 'application/pdf';

      const file = new Blob([res.data], { type: fileType });

      const fileURL = window.URL.createObjectURL(file);

      const fileWindow = window.open();
      if (fileWindow) {
        fileWindow.location.href = fileURL;
      }

      frontendNotification({
        message: t('successfullyProcessed'),
        type: 'success',
      });
    } else {
      throw res;
    }
  } catch (err: any) {
    frontendNotification({
      message: t('errorTryingToProcessReport'),
      type: 'error',
    });
  }
};
